(() => {
  let observer;
  const measure = () => {
    const header = document.querySelector('.kemper-header');
    if (!header) return;
    const paper = getComputedStyle(header, '::after');
    const paperBottom = paper.content !== 'none' && paper.content !== 'normal'
      ? (parseFloat(paper.top) || 0) + (parseFloat(paper.height) || 0)
      : 0;
    const height = Math.ceil(Math.max(header.getBoundingClientRect().height, paperBottom));
    document.documentElement.style.setProperty('--kemper-header-clearance', `${height}px`);
  };
  const observe = () => {
    observer?.disconnect();
    const header = document.querySelector('.kemper-header');
    if (!header) return;
    observer = new ResizeObserver(measure);
    observer.observe(header);
    measure();
  };
  observe();
  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', observe);
})();
